<template>
  <div>
    Logging in...
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  name: 'TrialLogin',
  data() {
    return {
      token: this.$route.params.token,
      loggingIn: false,
      error: null,
      email: null,
    }
  },
  created() {
    Api()
      .get("trial/userStore", {
        headers: { 'authorization': `Bearer ${this.token}` }
      })
      .then((response) => {
        if (response.data) {
          this.processStore(response);
          this.redirect();
        } else {
          this.showAlert("error", this.$t("message.error_generic"));
        }
      }).catch((err) => {
        if (err.response.status == 404) {
          this.error = this.$t("message.invalid_user");
        } else if (err.response.status == 400) {
          this.error = this.$t("message.invalid_password");
        } else { this.error = this.$t("message.error_generic") }
      });

  },
  methods: {
    processStore(response) {
      localStorage.removeItem("token");
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setInApp", false);
      this.$store.dispatch("setSelectedAcademy", null);
      this.$store.dispatch("setManagedAcademy", null);
      this.$store.dispatch("setStripeAccountId", null);
      this.$store.dispatch("setAcademyAdminStatus", null);

      this.$store.dispatch("setToken", this.token);
      this.$store.dispatch("setUser", response.data.user);
      this.$store.dispatch("setName", response.data.user.fName);
      this.$store.dispatch("setHidden", response.data.user.hidden);
      this.$store.dispatch("setInApp", false);

      this.$store.dispatch("setUserImage",
        (response.data.user.userImageSmall ?
          response.data.user.userImageSmall :
          response.data.user.userImage));
      this.$store.dispatch("setLanguage", response.data.user.lang);
      this.$i18n.locale = response.data.user.lang;
      localStorage.token = this.token;
      if (
        response.data.hasLatestAgreement &&
        response.data.hasLatestAgreement == true
      ) {
        localStorage.hasAgreements = true;
        this.$store.dispatch("setHasAgreements", true);
      } else {
        localStorage.hasAgreements = false;
        this.$store.dispatch("setHasAgreements", false);
      }
    },
    redirect() {
      window.location.replace("/secure/plus/academysetup")
    }
  }
}
</script>
